export default [
    {
        path: 'my-interactions',
        name: 'my-interactions',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.my_interactions').ucFirst();
            },
        },
        component: () => import('@/views/pages/interactions/interactions/own.vue')
    },
    {
        path: 'my-meetings',
        name: 'interactions-my-meetings',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.my_meetings').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'interactions-my-meetings-list' },
        children: [
            {
                path: '',
                name: 'interactions-my-meetings-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.my_meetings').ucFirst();
                    },
                },
                component: () => import('@/views/pages/interactions/meetings/own.vue')
            },
            {
                path: 'create',
                name: 'interactions-my-meeting-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('interactions::meetings.meeting', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/meetings/item.vue'),
                props: { own: true, interaction: true }
            },
            {
                path: ':id(\\d+)',
                name: 'interactions-my-meeting-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('interactions::meetings.meeting', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/meetings/item.vue'),
                props: { own: true, interaction: true },
            },
        ]
    },
    {
        path: 'my-offers',
        name: 'interactions-my-offers',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.my_offers').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'interactions-my-offers-list' },
        children: [
            {
                path: '',
                name: 'interactions-my-offers-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.my_offers').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/offers/own.vue')
            },
            {
                path: 'create',
                name: 'interactions-my-offer-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::offers.offer', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/offers/item.vue'),
                props: { own: true, interaction: true }
            },
            {
                path: ':id(\\d+)',
                name: 'interactions-my-offer-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::offers.offer', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/offers/item.vue'),
                props: { own: true, interaction: true },
            },
        ]
    },
    {
        path: 'my-contracts',
        name: 'interactions-my-contracts',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.my_contracts').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'interactions-my-contracts-list' },
        children: [
            {
                path: '',
                name: 'interactions-my-contracts-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.my_contracts').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/contracts/own.vue')
            },
            {
                path: 'create',
                name: 'interactions-my-contract-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::contracts.contract', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/contracts/item.vue'),
                props: { own: true, interaction: true }
            },
            {
                path: ':id(\\d+)',
                name: 'interactions-my-contract-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::contracts.contract', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/contracts/item.vue'),
                props: { own: true, interaction: true },
            },
        ]
    },
    {
        path: 'my-implements',
        name: 'interactions-my-implements',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.my_implements').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'interactions-my-implements-list' },
        children: [
            {
                path: '',
                name: 'interactions-my-implements-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.my_implements').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/implements/own.vue')
            },
            {
                path: 'create',
                name: 'interactions-my-implement-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::implements.implement', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/implements/item.vue'),
                props: { own: true, interaction: true }
            },
            {
                path: ':id(\\d+)',
                name: 'interactions-my-implement-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::implements.implement', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/implements/item.vue'),
                props: { own: true, interaction: true },
            },
        ]
    },
    {
        path: 'my-invoices',
        name: 'interactions-my-invoices',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.my_invoices').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'interactions-my-invoices-list' },
        children: [
            {
                path: '',
                name: 'interactions-my-invoices-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.my_invoices').ucFirst();
                    },
                },
                component: () => import('@/views/pages/invoices/invoices/own.vue'),
                props: { own: true, interaction: true }
            },
            {
                path: 'create',
                name: 'interactions-my-invoice-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('invoices::invoices.invoice', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/invoices/invoices/item.vue'),
                props: { own: true, interaction: true }
            },
            {
                path: ':id(\\d+)',
                name: 'interactions-my-invoice-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('invoices::invoices.invoice', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/invoices/invoices/item.vue'),
                props: { own: true, interaction: true },
            },
        ]
    },
    {
        path: 'actions',
        name: 'interactions-actions',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.actions').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'interactions-actions-list' },
        children: [
            {
                path: '',
                name: 'interactions-actions-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.actions').ucFirst();
                    },
                },
                component: () => import('@/views/pages/interactions/actions/list.vue')
            },
            {
                path: 'create',
                name: 'interactions-action-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('interactions::actions.action', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/actions/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'interactions-action-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('interactions::actions.action', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/actions/item.vue'),
            },
        ]
    },
    {
        path: 'accessible-meetings',
        name: 'interactions-accessible-meetings',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.accessible_meetings').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'interactions-accessible-meetings-list' },
        children: [
            {
                path: '',
                name: 'interactions-accessible-meetings-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.accessible_meetings').ucFirst();
                    },
                },
                component: () => import('@/views/pages/interactions/meetings/accessible.vue'),
                props: { accessible: true },
            },
            {
                path: 'create',
                name: 'interactions-accessible-meeting-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('interactions::meetings.meeting', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/meetings/item.vue'),
                props: { accessible: true },
            },
            {
                path: ':id(\\d+)',
                name: 'interactions-accessible-meeting-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('interactions::meetings.meeting', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/meetings/item.vue'),
                props: { accessible: true },
            },
        ]
    },
    {
        path: 'categories/:category(\\d+)',
        name: 'interactions-category',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.interaction_categories').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        children: [
            {
                path: 'monthly',
                name: 'interactions-category-monthly',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.monthly_interaction_categories').ucFirst();
                    },
                },
                component: () => import('@/views/pages/interactions/categories/monthly.vue'),
            },
            {
                path: 'create',
                name: 'interactions-category-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('interactions::categories.category', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/interactions/categories/interaction.vue'),
            },
        ]
    }
]